import { render } from "./LanguageSwitcher.vue?vue&type=template&id=4b52c3bc"
import script from "./LanguageSwitcher.vue?vue&type=script&lang=js"
export * from "./LanguageSwitcher.vue?vue&type=script&lang=js"

import exportComponent from "/dev/shm/repo/portfolio-dp7mkww8fwx8/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__